import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getComboDireccionClienteActivo`, method: 'GET', body: null, token: token})
}